import { render, staticRenderFns } from "./MinaSidorTable.vue?vue&type=template&id=7318630a&scoped=true"
import script from "./MinaSidorTable.vue?vue&type=script&lang=js"
export * from "./MinaSidorTable.vue?vue&type=script&lang=js"
import style0 from "./MinaSidorTable.vue?vue&type=style&index=0&id=7318630a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7318630a",
  null
  
)

export default component.exports